import { Accordion, AccordionDetails, AccordionSummary, TableCell, TableRow } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { DotLegalCheckbox, DotLegalHeader } from "@dotlegal/dotlegal-ui-components";
import { ITableHeader } from "@dotlegal/dotlegal-ui-components/dist/cjs/types/components/dotLegalTable/DotLegalTable.types";
import DotLegalTableWithControlsLocalized from "../../../common/components/dotLegalTableWithControlsLocalized/DotLegalTableWithControlsLocalized";
import { useTranslation } from "@localization/useTranslation";
import { useEntityTemplatePermissions } from "./EntityTemplatePermissions.hooks";
import { getEntityTemplateTranslationKeys, TemplateEntityType } from "../../../entityTemplates/EntityTemplate.types.ts";

export interface EntityTemplatePermissionsProps {
    roleId: string;
    readOnly: boolean;
    expanded: boolean;
    onExpandToggle: () => void;
    templateEntityType: TemplateEntityType;
}

interface TemplateRow {
    id: string;
    name: string;
}

function EntityTemplatePermissions(props: EntityTemplatePermissionsProps) {
    const { translateString } = useTranslation();
    const { isLoading, templates, isTemplateIncluded, toggleTemplate, onSelectAllChanged, headerCheckBoxState } = useEntityTemplatePermissions(props);

    function getHeaders(): ITableHeader<TemplateRow>[] {
        return [{ property: "name", text: translateString("name"), align: "left", showOnMobile: true }];
    }

    if (templates.length === 0 && !isLoading) return null;

    return (
        <Accordion expanded={props.expanded} onChange={props.onExpandToggle}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <DotLegalHeader marginBottom={0} headerStyle={"extraSmall"}>
                    {translateString(getEntityTemplateTranslationKeys(props.templateEntityType).templates)}
                </DotLegalHeader>
            </AccordionSummary>
            <AccordionDetails>
                <DotLegalTableWithControlsLocalized
                    data={templates}
                    headers={getHeaders()}
                    defaultOrderBy={"name"}
                    defaultOrder={"asc"}
                    isLoading={isLoading}
                    clickableRows={false}
                    headerCheckBoxState={headerCheckBoxState}
                    onSelectAllChanged={onSelectAllChanged}
                    hidePagination
                    getUserSpecificPageLength={() => undefined}
                    renderRow={(row) => (
                        <TableRow key={row.id} onClick={() => toggleTemplate(row.id)} sx={{ cursor: "pointer" }}>
                            <TableCell>
                                <DotLegalCheckbox margin={{ marginLeft: -1.5 }} checked={isTemplateIncluded(row.id)} disabled={props.readOnly} />
                            </TableCell>
                            <TableCell>{row.name}</TableCell>
                        </TableRow>
                    )}
                />
            </AccordionDetails>
        </Accordion>
    );
}

export default EntityTemplatePermissions;
